var generateStyle = function generateStyle(componentTheme) {
  return {
    panel: {
      flex: 1,
      padding: componentTheme.panelPadding
    },
    row: {
      display: 'flex'
    }
  };
};
export default generateStyle;